const fr = {
  brand: "VytaliBoots",
  nav: {
    home: "Accueil",
    discover: "Découvrir",
    events: "Événements",
    partners: "Partenaires",
    challenges: "Challenges",
    creators: "Créateurs",
    join: "Rejoindre",
    login: "Connexion",
    account: "Mon compte",
    admin: "Admin",
    logout: "Déconnexion",
  },
  home: {
    hero_title: "VytaliBoots",
    hero_primary: "La mémoire vivante de Vytali.",
    hero_support: "Rencontrez. Créez. Capturez. Partagez.",
    cta_join: "Rejoindre VytaliBoots",
    cta_discover: "Découvrir",
    faces: "Visages de Vytali",
    now: "Boots en ce moment",
    experiences: "Expériences",
    partner_spotlight: "Partenaire en vedette",
    challenges: "Challenges",
    creators: "Créateurs",
    final_cta: "Faites partie de l'histoire de Vytali.",
    be_ambassador: "Devenir Ambassadeur",
    be_creator: "Devenir Créateur",
    be_talent: "Participer comme Talent",
    be_partner: "Devenir Partenaire",
  },
  profile_types: {
    member: "Membre",
    ambassador: "Ambassadeur",
    creator: "Créateur",
    influencer: "Influenceur",
    model: "Mannequin",
    talent: "Talent",
    photographer: "Photographe",
    videographer: "Vidéaste",
    filmmaker: "Réalisateur",
    event_personality: "Personnalité d'événement",
    production_partner: "Partenaire de production",
  },
  interests: {
    ambassador: "Ambassadeur Vytali",
    creator_influencer: "Créateur / Influenceur",
    model_talent: "Mannequin / Talent",
    photographer: "Photographe",
    videographer_filmmaker: "Vidéaste / Réalisateur",
    event_participation: "Participation aux événements",
    partner_business: "Entreprise partenaire",
    other_creative: "Autre collaboration créative",
  },
  statuses: {
    all: "Tous",
    new: "Nouvelle",
    reviewing: "En révision",
    contacted: "Contacté",
    approved: "Approuvée",
    declined: "Refusée",
    waitlisted: "Liste d'attente",
    submitted: "Soumise",
    verified: "Vérifiée",
    rejected: "Rejetée",
    winner: "Gagnante",
    open: "Ouvert",
    closed: "Fermé",
    draft: "Brouillon",
  },
  common: {
    demo: "Démo",
    loading: "Chargement…",
    empty: "Aucun contenu pour le moment.",
    error: "Une erreur est survenue.",
    photo: "Photo",
    video: "Vidéo",
    back: "Retour",
    save: "Enregistrer",
    cancel: "Annuler",
  },
};

export default fr;
